
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/team/statistics",
      function () {
        return require("private-next-pages/team/statistics.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/team/statistics"])
      });
    }
  